import {Routes} from '@angular/router';
import {ChannelDetailComponent} from '../../views/btv/channel-detail/channel-detail.component';


export const SECURE_ROUTES: Routes = [
  {path: 'channelDetail/:id', component: ChannelDetailComponent},


];



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/layouts/secure/secure.routes.ts